<!--
- 专题表格（手机端）
- author: lzp
- greatTime: 2019-10-30
-->
<template lang="html">
  <div class="table-container">
    <div class="table-item" v-for="table in list" v-if="$route.name != 'MSpecialDetail' || table.table_status == '1'" :key="table.id">
      <template v-if="table.hide_title != '1'">
        <p class="title" v-if="table.type == 0"><i class="iconfont">&#xe66a;</i> {{table.title}}</p>
        <div class="top-title" v-else>
          <div class="font">{{table.title}}</div>
        </div>
      </template>
      <p class="summary" :class="table.type == 1 ? 'smy-center' : ''" v-if="table.summary" v-html="table.summary"></p>
      <div style="position: relative; overflow: hidden; min-height: 1.2rem">
        <div style="width: 0; height: 0; overflow: hidden;">  
          <div :class="{'table-area': true, 'l-tab': uid == tempuid, 'toplist': table.type == 1}" :id="'table-area'+table.id" v-show="!list_all['table'+table.id]['img_url']">
            <div class="table-header">
              <p 
                v-for="(item, index) in list_all['table'+table.id]['list_header']" 
                :key="item.name" 
                :style="{'width':colWidth(list_all['table'+table.id]['width_list'][index],list_all['table'+table.id]['s_width'])+'%'}"
                :class="{'rank': item.meta == '序号'}"
              >{{item.name}}</p>
            </div>
            <div class="table-row" v-for="(row, row_index) in list_all['table'+table.id]['deal_list']" :key="row_index">
              <p 
                v-for="(item, index) in list_all['table'+table.id]['list_header']" 
                :key="item.name" 
                :style="{'width':colWidth(list_all['table'+table.id]['width_list'][index],list_all['table'+table.id]['s_width'])+'%'}"
                :class="item.meta == '序号'? 'rank top'+ row[item.name] : ''"
              >{{row[item.name]}}</p>
            </div>
          </div>
        </div>
        <img class="table-area-img" :preview="table.id" :src="list_all['table'+table.id]['img_url']" v-show="list_all['table'+table.id]['img_url']">
        <div class="loading_img" v-if="!list_all['table'+table.id]['img_url']">
          <div class="con"><span class="loader-box"></span><br><p>表格生成中</p></div>
        </div>
      </div>
      <div class="share-area">
        <p>数据来源：{{table.src | empty('动脉橙产业智库')}}</p>
        <div class="right" @click="goShare(table.id)">
          <span>分享至</span>
          <div>
            <i class="iconfont">&#xe641;</i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import html2canvas from 'html2canvas'
export default {
  data() {
    return {
      // list_header: [], // 表头
      // deal_list: [] // 处理后的数据,机构如下()
      list_all: {}
    }
  },
  props: ['list', 'uid', 'tempuid'],
  methods: {
    dealList() {
      for(let m of this.list) {
        if(this.$route.name === 'MSpecialDetail') {
          if (m.table_status == '0') {
            continue
          }
        }
        this.list_all['table'+m.id] = {
          img_url: '',
          list_header: [],
          deal_list: [],
          width_list: [],
          s_width: 0,
          table_type: m.type // 1是排行
        }
        let tarr = []
        if (m.table_data.length) {
          tarr = m.table_data[0].table_content.filter((b) => b.meta == '序号')
        }
        for(let i = 0; i<m.table_data.length; i++) {
          let temp = {}
          let temp_arr = m.table_data[i].table_content       
          if(tarr.length == 0 && m.type == 1) {
            temp_arr.unshift({
              col_width: 50,
              content_type: "",
              content_uid: "",
              element_id: "13",
              element_name: "排名",
              element_value: i + 1,
              meta: "序号"
            })
          }
          for(let j = 0; j< temp_arr.length; j++) {
            if (i == 0) {
              this.list_all['table'+m.id]['list_header'].push({
                name: temp_arr[j].element_name,
                meta: temp_arr[j].meta
              })
              if (temp_arr[j].meta == '序号') {
                this.list_all['table'+m.id]['s_width'] = this.list_all['table'+m.id]['s_width'] + 0
                this.list_all['table'+m.id]['width_list'].push(0)
              } else {
                this.list_all['table'+m.id]['s_width'] = this.list_all['table'+m.id]['s_width'] + temp_arr[j].col_width
                this.list_all['table'+m.id]['width_list'].push(temp_arr[j].col_width)
              }
            }
            temp[temp_arr[j].element_name] = temp_arr[j].element_value
          }
          this.list_all['table'+m.id]['deal_list'].push(temp)
        }
      }
      this.$nextTick(() => {
        for(let m of this.list) {
          if(this.$route.name === 'MSpecialDetail') {
            if (m.table_status == '0') {
              continue
            }
          }
          this.toImg(m.id)
        }
      })
    },
    toImg(table_id) {
      html2canvas(document.getElementById('table-area'+table_id),{scale: 2, useCORS: true, tainttest: true, logging: false}).then((canvas) => { // canvas是个dom对象
        let save_url=canvas.toDataURL("image/png")
        this.list_all['table'+table_id]['img_url'] = save_url
        this.$forceUpdate()
        this.$previewRefresh()
      })
    },
    goShare(id) {
      this.$router.push({name: 'MShareTable',query: {theme_uid: this.$route.params.uid,table_id:id}})
    },
    colWidth(c, s) { // 算列宽
      return (c/s)*100
    }
  },
  created() {
    this.dealList()
  }
}
</script>

<style lang="stylus" scoped>
@import '~mobile/styles/shareLoading.stylus'
.loading_img
  position: absolute
.table-container
  margin-top: .3rem;
  .table-item
    .top-title
      display flex
      justify-content center
      background url('~pic/topfontbg.png') top center no-repeat
      background-size auto .58rem
      padding-bottom .3rem
      .font
        font-size .38rem
        line-height 1.2
        padding .3rem .9rem 0
        color #404877
        position relative
        text-align center
        &:before, &:after
          content ''
          position absolute
          width .74rem
          height .14rem
          background url('~pic/topfontlt.png') center no-repeat
          background-size 100% 100%
          top .44rem
          left 0
        &:after
          left auto
          right 0
          background url('~pic/topfontrt.png') center no-repeat
          background-size 100% 100%
    .title
      color: #333333;
      font-size: .32rem;
      font-weight: bold;
      margin-bottom: .14rem;
      i
        font-weight: normal;
        color: #FA5A00;
        font-size: .34rem;
    .summary
      font-size: .28rem;
      margin-bottom: .3rem;
      color: #333333;
      line-height: .44rem;
      // font-weight: bold;
      &.smy-center
        text-align: center
    .table-area
      width: 700px;
      background-image: url('~pic/watermark-gray.png');
      overflow: auto;
      .table-header,.table-row
        display: flex;
        // padding: .2rem 0;
        align-items: center;
        p
          min-height: .80rem;
          color: #333333
          padding: 0 .2rem;
          font-size: .24rem;
          word-break: break-all;
          line-height: .36rem;
          display: flex;
          align-items: center;
        p+p
          border-left: 1px solid #eee
      .table-header
        background:  #ffa961
        p
          color: #FFFFFF
          font-weight: bold
          &.rank
            justify-content: center;
            padding: 0
            min-width 50px
      .table-row
        .rank
          justify-content: center;
          font-size: .36rem;
          font-weight: bold;
          padding: 0
          min-width 50px
      .table-row:nth-child(2n)
        .rank
          color: #ffcda3
      .table-row:nth-child(2n-1)
        background: rgba(255,136,36,.2)
        .rank
          color: #fff
      &.l-tab
        .table-header
        .table-row
          p
            line-height: .64rem
            font-size: .4rem
      &.toplist
        .table-header
          background: linear-gradient(0deg, #3D4575 0%, #292D4D 100%);
          p+p
            border-left: 0
        .table-row
          p+p
            border-left: 0
        .table-row:nth-child(2n)
          .rank
            color: #DAB693
        .table-row:nth-child(2n-1)
          background: rgba(186, 190, 211, .2)
          .rank
            color: #DAB693
        .top1, .top2, .top3
          font-size 0
          line-height 1
          &:before
            content ''
            background-image url('~pic/tabletop1.png')
            width .42rem
            height .47rem
            display inline-block
            background-size 100% auto
        .top2
          &:before
            background-image url('~pic/tabletop2.png')
        .top3
          &:before
            background-image url('~pic/tabletop3.png')

    .table-area-img
      width: 100%;
    .share-area
      margin-top: .34rem;
      display: flex;
      justify-content: space-between;
      p
        color: #999999;
        font-size: .24rem;
        line-height: .32rem;
      .right
        display: flex;
        margin-left: .4rem;
        min-width: 1.6rem;
        span
          font-size: .24rem;
          color: #999999;
          margin-top: 0.02rem;
        div
          width: .68rem;
          height: .68rem;
          background: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
          border: 1px #eee solid;
          margin-top: -.17rem;
          margin-left: .2rem;
          i
            color: rgb(46, 198, 107);
            font-size: .40rem;
  .table-item+.table-item
    margin-top: .3rem
</style>
